import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  public show: boolean = false;
  constructor() { }

  ngOnInit(): void {
  }
  toggle() {
    this.show = !this.show;
    document.body.classList.toggle('bodyActive');
  }
}
